import { Phone, MessageCircle } from "lucide-react";
import { SITE, buildWhatsAppUrl } from "@/lib/site";

const FloatingButtons = () => {
  return (
    <div
      data-testid="floating-actions"
      className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3"
    >
      <a
        href={`tel:${SITE.phoneRaw}`}
        aria-label="Call Navilukallu Homestay"
        data-testid="floating-call-button"
        className="group w-14 h-14 rounded-full bg-[#1B4332] text-[#D4AF37] flex items-center justify-center shadow-xl hover:scale-105 transition-all duration-300 border border-[#D4AF37]/30"
      >
        <Phone size={22} strokeWidth={1.7} />
      </a>
      <a
        href={buildWhatsAppUrl("Hi Navilukallu Homestay, I have a query.")}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp Navilukallu Homestay"
        data-testid="floating-whatsapp-button"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl fab-pulse hover:scale-105 transition-transform"
      >
        <MessageCircle size={24} strokeWidth={1.7} />
      </a>
    </div>
  );
};

export default FloatingButtons;
